import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SearchDropdown from '../../../../Components/Dropdown/dropdown';
import { Button } from 'primereact/button';

// Helper to transform objects with only a `name` property into { label, value }
const formatOptions = (options = []) =>
  options.map((item) => {
    if (typeof item === 'string' || typeof item === 'number') {
      return { label: String(item), value: item };
    }
    const value = [
      item.value,
      item.id,
      item.employeeId,
      item.employee_id,
      item.projectId,
      item.project_id,
      item.project_seq_id,
      item.requestTypeId,
      item.request_type_id,
      item.req_access_type_id,
      item.aiToolId,
      item.ai_tool_id,
    ].find((optionValue) => optionValue !== undefined && optionValue !== null && optionValue !== '');
    return {
      label: item.name || item.label || '',
      value: value ?? '',
    };
  });

const AddAiAccessReqModal = ({ open, onClose, onSubmit, dropDownOptions, onSelectionsChange, isSubmitting }) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedRequestType, setSelectedRequestType] = useState(null);
  const [selectedAiTool, setSelectedAiTool] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [businessJustification, setBusinessJustification] = useState('');
  const employeeDropdownCss = selectedProject
    ? 'add-ai-access-req-search-dropdown'
    : 'add-ai-access-req-search-dropdown add-ai-access-req-employee-dropdown-disabled';

  const handleSubmit = () => onSubmit({
    employees: selectedEmployee,
    requestType: selectedRequestType,
    aiTools: selectedAiTool,
    project: selectedProject,
    businessJustification,
  });

  useEffect(() => {
    if (!open) return undefined;

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [open]);

  if (!open) return null;
  return (
    <div className="add-ai-access-req-modal-backdrop" onClick={onClose}>
      <div className="add-ai-access-req-modal" onClick={(event) => event.stopPropagation()}>
        <div className="modal-content-header">
          <h2>Add AI Access Request</h2>
        </div>
        <div className="modal-content-body">
          <div className="add-ai-access-req-input-wrapper">
            <label>
              <span className="required-label">Employee Name<span className="asteric">*</span></span>
            </label>
            <SearchDropdown
              options={formatOptions(dropDownOptions?.employee)}
              placeholder={selectedProject ? 'Select Employee (s)' : 'Select a project first'}
              value={selectedEmployee}
              onChange={(event) => {
                const employees = event.target.value;
                setSelectedEmployee(employees);
                onSelectionsChange({ employees, project: selectedProject });
              }}
              multiSelect={true}
              searchBox={true}
              disabled={!selectedProject}
              initialVisibleCount={8}
              clearIcon={true}
              dropdownCss={employeeDropdownCss}
            />
          </div>
          <div className="add-ai-access-req-input-wrapper">
            <label>
              <span className="required-label">Request Type<span className="asteric">*</span></span>
            </label>
            <SearchDropdown
              options={formatOptions(dropDownOptions?.accessRequestType)}
              placeholder="Select Request Type"
              value={selectedRequestType}
              onChange={(event) => setSelectedRequestType(event.target.value)}
              searchBox={false}
              initialVisibleCount={8}
              clearIcon={true}
              dropdownCss="add-ai-access-req-search-dropdown"
            />
          </div>
          <div className="add-ai-access-req-input-wrapper">
            <label>
              <span className="required-label">AI Tool Names<span className="asteric">*</span></span>
            </label>
            <SearchDropdown
              options={formatOptions(dropDownOptions?.aiTool)}
              placeholder="Select AI Tool (s)"
              value={selectedAiTool}
              onChange={(event) => setSelectedAiTool(event.target.value)}
              multiSelect={true}
              searchBox={true}
              clearIcon={true}
              dropdownCss="add-ai-access-req-search-dropdown"
            />
          </div>
          <div className="add-ai-access-req-input-wrapper">
            <label>
              <span className="required-label">Project Name<span className="asteric">*</span></span>
            </label>
            <SearchDropdown
              options={formatOptions(dropDownOptions?.project)}
              placeholder="Select Project"
              value={selectedProject}
              onChange={(event) => {
                const project = event.target.value;
                setSelectedProject(project);
                setSelectedEmployee([]);
                onSelectionsChange({ employees: [], project });
              }}
              searchBox={true}
              clearIcon={true}
              dropdownCss="add-ai-access-req-search-dropdown"
            />
          </div>
          <div className="add-ai-access-req-input-wrapper">
            <label>
              <span className="required-label">Business Justification<span className="asteric">*</span></span>
            </label>
            <textarea
              className="add-ai-access-req-textarea"
              value={businessJustification}
              onChange={(event) => setBusinessJustification(event.target.value)}
              required
            />
          </div>
        </div>
        <div className="modal-content-footer">
          <div className="footer-btn-wrapper">
            <Button label="Cancel" onClick={onClose} className="p-button-cancel" text/>
            <Button label="Submit"
              onClick={handleSubmit} className="p-button-submit" loading={isSubmitting} disabled={isSubmitting} />
          </div>
        </div>
      </div>
    </div>
  );
};

AddAiAccessReqModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  dropDownOptions: PropTypes.shape({
    employee: PropTypes.array,
    project: PropTypes.array,
    accessRequestType: PropTypes.array,
    aiTool: PropTypes.array,
  }).isRequired,
  onSelectionsChange: PropTypes.func.isRequired,
};
AddAiAccessReqModal.defaultProps = {
  isSubmitting: false,
};
export default AddAiAccessReqModal;
